import React from 'react';

const toFullName = (person = {}) =>
  `${person.firstName || ''} ${person.middleName || ''} ${person.lastName || ''}`
    .replace(/\s+/g, ' ')
    .trim();

export const renderFullNameCell = (getPerson) => (params) => {
  const person = getPerson ? getPerson(params) : params.value;

  return <span>{toFullName(person) || '-'}</span>;
};
